<template>
  <div style="position: relative;">
    <div class="overlay" @click="$emit('close')" />
    <div class="modal-content">
      <form class="form-inline">
        <div v-if="search" class="form-group input-group">
          <span
            style="background: white; border-width: 0px 0px 1px 0px; border-radius: 0px;"
            class="input-group-addon"
            ><i class="fa fa-search icon"></i
          ></span>
          <input
            type="text"
            style="width: 100%; margin: 0px; border-radius: 0px; border-width: 0px 0px 1px 0px;"
            placeholder="search"
            v-model="searchQuery"
            class="form-group input-group"
          />
        </div>
        <div
          v-for="propertyObj in searchFilteredPropertyArray"
          v-if="propertyObj.array.length > 0"
        >
          <h5 v-if="alphabet" style="margin-right: 10px; float: right;">
            {{ propertyObj.letter }}
          </h5>
          <input
            v-for="item in propertyObj.array"
            type="button"
            class="btn-default"
            style="margin: 0px; border-radius:0px; width: 100%; border-width: 0px 0px 1px 0px; display: block; text-align: left;"
            :value="item.name"
            v-bind:class="{
              selected: isSelectedProperty(property, propertyName, item)
            }"
            v-on:click="toggleProp(item)"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import textInput from "./textInput.vue";
import { mapGetters, mapActions } from "vuex";
import utils from "../components/utils.js";

export default {
  data() {
    return {
      propertyArray: [],
      searchQuery: ""
    };
  },
  name: "multi-select-modal",
  props: {
    property: undefined,
    propertyName: undefined,
    alphabet: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    }
  },
  components: {
    textInput: textInput
  },
  methods: {
    toggleProp: function(item) {
      if (!this.isSelectedProperty(this.property, this.propertyName, item)) {
        var index = this.propList.length;
        this.$store.commit("createNewProviderProperty", this.property);
        var payl = {
          data: item,
          keyChain: [this.property, index, this.propertyName]
        };
        this.$store.commit("setEditedProviderByKeyChain", payl);
        var payl = {
          data: item.id,
          keyChain: [this.property, index, this.propertyName + "_id"]
        };
        this.$store.commit("setEditedProviderByKeyChain", payl);
      } else {
        var index = this.propList.findIndex(providerItem => {
          return providerItem[this.propertyName + "_id"] == item.id;
        });
        this.$store.commit("deleteEditedProviderPropertyByKeyChain", [
          this.property,
          index
        ]);
      }
    },
    arrangePropertyListByLetter(letter) {
      return this.properties(this.propertyName)
        .sort((prop1, prop2) => {
          var textA = prop1.name.toUpperCase();
          var textB = prop2.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        })
        .filter(prop => {
          return prop.name[0].toUpperCase() == letter.toUpperCase();
        });
    }
  },
  computed: {
    ...mapGetters({
      getEditedProperty: "getEditedProviderValueByKeyChain",
      properties: "providerPropertyToProperty",
      isSelectedProperty: "isSelectedProperty"
    }),
    propList: function() {
      return this.$store.getters.getEditedProviderValueByKeyChain([
        this.property
      ]);
    },
    searchFilteredPropertyArray: function() {
      if (this.searchQuery != "") {
        var filteredPropertyArray = this.propertyArray.map(collection => {
          return {
            letter: collection.letter,
            array: collection.array.filter(item => {
              return (
                item.name
                  .toLowerCase()
                  .indexOf(this.searchQuery.toLowerCase()) > -1
              );
            })
          };
        });
        return filteredPropertyArray;
      } else {
        return this.propertyArray;
      }
    }
  },
  created() {
    const alphabet = utils.alphabet();
    for (var letter of alphabet) {
      this.propertyArray.push({
        letter: letter,
        array: utils.arrangeListByLetter(
          this.properties(this.propertyName),
          letter
        )
      });
    }
  }
};
</script>

<style scoped>
.options {
  display: inline-block;
  margin-left: 10px;
}

.modal-content {
  position: absolute;
  z-index: 1;
  padding-top: 200px;
  top: 70px;
  background-color: #fefefe;
  margin: auto;
  padding: 0px;
  border: 1px solid #888;
  max-height: 60vh;
  overflow: scroll;
}

.modal-default-button {
  float: right;
}
.selected {
  color: lightgrey;
}

.dropbtn {
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: lightgrey;
}

input[type="text"] {
  width: 200px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

.overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/elements/multiSelectModal.vue